const TipoPagoIvaRetOptions = [
  {
    label: 'Selecciona',
    value: ''
  },
  {
    label: "Pago definitivo IVA (01)",
    value: "01"
  }
];

export default TipoPagoIvaRetOptions;